import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { Location } from '@angular/common';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { StoreCartBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storecartbase';
import { ModifierSetBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifersetbase';
import { ItemBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { VariantBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-variantbase';
import { ModifierSetOptionBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifieroptionbase';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EcomValidator } from 'src/app/ecom-services/ecom-validation';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { EcomCookies } from '../../ecom-services/ecom-cookies';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { WindowRef } from '../../ecom-support-center/zoho-salesiq/WindowRef';
import $ from 'jquery';
import { DomSanitizer } from '@angular/platform-browser';
import { EComGoogleAnalytics } from '@src/app/ecom-services/ecom-google-analytics';

declare var chatWindowLoad: Function;

@Component({
  selector: 'app-ecom-status-delivery',
  templateUrl: './ecom-status-delivery.component.html',
  styleUrls: ['./ecom-status-delivery.component.scss'],
  providers: [WindowRef]
})
export class EcomStatusDeliveryComponent implements OnInit {
  // Method to handle the back button click
  window: any;
  overlayDisplay = false;
  timeleft = '';
  statusCheckMessage = '';
  settings: any;
  locationSelected: any;
  orderlocationDetails: any;
  userServiceBase: UserServiceBase;
  userSelectedStore: StoreServiceBase;
  modalRef: BsModalRef;
  config_sm = {
    animated: true,
    class: 'modal-dialog-centered modal-sm'
  };
  config = {
    animated: true,
    class: 'modal-dialog-centered'
  };
  serviceType: any;
  statusMessage = 'preparing you order';
  statusinput = {
    companyId: '',
    companyGuid: '',
    locationGuid: '',
    oocrs_oodcdr_guid: '',
    oocrs_guid: '',
    OrderStatus: ''
  };
  statusWidth = '5%';
  statusWidthNumber = 0;
  percentageWidth = 0;
  orderDetails: any;
  timeoutFunc: any;
  GetStatusDisable = true;
  progressStartTime: any;
  progressEndTime: any;
  orderStatus = '';
  alerts: any[] = [{
    type: 'warning',
    msg: 'service started',
    timeout: 5000,
    isOpen: false
  }];
  autoStatusTimeOut: any;
  paymentStatus = '0';
  cashbackamount = 0;
  invoiceEmail = '';
  invoiceMsg = '';
  invoiceRequest = true;
  currency = '';
  position = 'FRONT';
  orderDatetime = '';
  LogoPath = '';
  invoiceNumber = '';
  emailForm: FormGroup;
  CompanyBusinessNumber = '';
  taxList = [];
  referForm: FormGroup;
  referMessage = '';
  referSuccess = false;
  referPhoneNumber = '';
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  selectedCountryISO: any = CountryISO.Malaysia;
  preferredCountries: CountryISO[] = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];
  refererinput = {
    name: '',
    dial_code: '',
    mobile: '',
    company_guid: '',
    company_id: '',
    key: ''
  };
  referralDiscount: any;
  rejectreason = '';
  discountsApplied: any;
  paymentMethod = undefined;
  olarPoints = 0;
  configOlarmePromotionPopup = {
    animated: true,
    class: 'modal-dialog-centered modal-sm',
    ignoreBackdropClick: true,
    keyboard: false
  };
  @ViewChild('olarmepromotionpopup', { static: true }) olarmepromotionpopup: ElementRef;
  modalRefOlarmePromotion: BsModalRef;
  driverAssigned = false;
  driverDetails = {
    deliveryStatus: '',
    deliveryPartner: '',
    name: '',
    contact: '',
    image: './assets/images/profile.png',
    vehiclenumber: '',
    trackingUrl: '',
    lat: '',
    lng: '',
    last_updated: ''
  }
  configOrderTrackPopup = {
    animated: true,
    class: 'modal-dialog-centered modal-lg',
    ignoreBackdropClick: true,
    keyboard: false
  };
  @ViewChild('orderTrack', { static: true }) orderTrack: ElementRef;
  modalRefOrderTrack: BsModalRef;
  @ViewChild('trackingUrl', { static: true }) trackingUrl: ElementRef;
  deliveryTrackingUrl: any;
  deliveryTrackingUrl1: any;
  chatUrl: any;
  configChatPopup = {
    animated: true,
    class: 'modal-dialog-centered modal-lg',
    ignoreBackdropClick: true,
    keyboard: false
  };
  @ViewChild('chatbox', { static: true }) chatbox: ElementRef;
  modalRefChatbox: BsModalRef;
  //loaylty points window
  modalRefLoyalty: BsModalRef;
  @ViewChild('displayLoyalty', { static: true }) displayLoyalty: ElementRef;
  configloyalty = {
    animated: true,
    class: 'modal-dialog-centered modal-sm modal-loyalty-status',
    ignoreBackdropClick: false,
    keyboard: true
  };
  loayltyEarnedPoints = 0;
  loyaltyCurrentBalance = 0;
  isLoayltyMemberAlready = true;
  loyaltyEmail = "";
  loyaltyPhoneAndName = false;
  loyaltyJoinForm: any;
  redirect = false;
  loyaltyMessage = "";
  active = 0;
  // constructor to inject the class objects
  constructor(private eComGoogleAnalytics: EComGoogleAnalytics, public sanitizer: DomSanitizer, private winRef: WindowRef, public formBuilder: FormBuilder, public router: Router, public ecomservice: EComService, private webstorage: EComWebStorage, private cookie: EcomCookies,
    private modalService: BsModalService, private toastr: ToastrService, public location: Location, public activatedRoute: ActivatedRoute) {
    this.userSelectedStore = new StoreServiceBase();
    this.userServiceBase = new UserServiceBase();
    this.userSelectedStore.storeCart = new StoreCartBase();
    this.window = winRef.nativeWindow;
  }

  // Close loyalty Pop-up
  closeLoyalty() {
    this.modalRefLoyalty.hide();
  }

  redirectUser(remaining) {
    this.redirect = true;
    //redirect
    let m = Math.floor(remaining / 60);
    let s = remaining % 60;
    m = m < 10 ? 0 + m : m;
    s = s < 10 ? 0 + s : s;
    if (document.getElementById('redirect')) {
      document.getElementById('redirect').innerHTML = ('0' + m).slice(-2) + ' : ' + ('0' + s).slice(-2);
    }
    remaining -= 1;
    if (remaining >= 0 && this.redirect) {
      let temp = this;
      setTimeout(function () {
        temp.redirectUser(remaining);
      }, 1000);
      return;
    }
    this.redirect = false;
    this.modalRefLoyalty.hide();
    // update name and phone number
    this.active = 0;
    this.userServiceBase.userName = this.loyaltyJoinForm.value.loyaltyName;
    this.userServiceBase.userMobile = this.loyaltyJoinForm.value.loyaltyPhoneNumber.e164Number;
  }

  onAcceptLoyaltyClick() {
    if (this.loyaltyJoinForm.invalid) {
      Object.keys(this.loyaltyJoinForm.controls).forEach(key => {
        this.loyaltyJoinForm.get(key).markAsDirty();
      });
      return;
    } else {
      this.active = 1;
      let input = {
        'companyId': this.webstorage.sessionSt_status_companyid,
        'customer_email': this.loyaltyJoinForm.value.loyaltyEmail,
        'customer_phone_number': this.orderDetails['UserMobile'],
        'customer_country_dial_code': this.orderDetails['UserDialCode'],
        'customer_first_name': this.orderDetails['oodcdr_name'],
        'order_guid': this.orderDetails['oodcdr_guid'],
        'location_guid': this.orderDetails['oodcdr_location_guid'],
        'company_guid': this.orderDetails['oodcdr_company_guid'],
        'public_key': this.webstorage.localSt_olar_key
      };
      // ecrypt the details
      input['customer_first_name'] = this.ecomservice.encryptWithKey(input['customer_first_name']);
      input['customer_phone_number'] = this.ecomservice.encryptWithKey(input['customer_phone_number']);
      input['customer_country_dial_code'] = this.ecomservice.encryptWithKey(input['customer_country_dial_code']);
      input['customer_email'] = this.ecomservice.encryptWithKey(input['customer_email']);
      this.ecomservice.httpPost(EcomNetworkUtils.POST_JOIN_LOYALTY, input, '', true).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          this.redirectUser(5);          
        }
      });
    }
  }

  getMerchantCustomerLoyaltyDetails(companyId, mobileNumber, dialCode, salesOrderGuid) {
    //mobileNumber = '1123091111';
    console.log('getMerchantCustomerLoyaltyDetails');
    this.ecomservice.httpGet(EcomNetworkUtils.GET_MERCHANT_CUSTOMER_LOYALTY + "?companyId=" + companyId + '&mobilNumber=' + mobileNumber + '&dialCode=' + dialCode + '&salesOrderGuid=' + salesOrderGuid, '', true).subscribe((response) => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
          if (response['listValue']['merchantLoyaltyActive'] && response['listValue']['customerEarnedPointsCurrent'] > 0) {
            this.loayltyEarnedPoints = response['listValue']['customerEarnedPointsCurrent'];
            this.loyaltyCurrentBalance = response['listValue']['customerTotalPoints'];
            this.isLoayltyMemberAlready = response['listValue']['customerLoyaltyMember'];
            this.modalRefLoyalty = this.modalService.show(this.displayLoyalty, this.configloyalty);
          }
        }
      }
    });
  }

  // component initialize and load the required data
  ngOnInit() {
      this.webstorage.sessionSt_user_order_reference = undefined;
    let gTag = {
      'event': 'screen_view',
      'screen_name': 'status-delivery'
    };
    this.eComGoogleAnalytics.customEvent(gTag);
    //chatWindowLoad('block');
    this.cookie.deleteCheckoutCookies();
    this.loyaltyJoinForm = this.formBuilder.group({
      loyaltyEmail: ['', Validators.compose([EcomValidator.emailValidator])]
    });
    //this.webstorage.clear('localst_userservicerequest', 'LOCAL');
    if (this.webstorage.sessionSt_qr_code_scanned === undefined || this.webstorage.sessionSt_qr_code_scanned === null) {
      this.webstorage.clear('localst_userservicerequest', 'LOCAL');
    }
    else {
      let tempUserServiceBase = new UserServiceBase();
      tempUserServiceBase = this.webstorage.localSt_user_service_request;
      tempUserServiceBase.selectedStoreServiceList.forEach(element => {
        element.storeCart = new StoreCartBase();
      });
      this.webstorage.localSt_user_service_request = tempUserServiceBase;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    // alert message
    this.alerts = [];
    this.alerts.push({
      type: 'warning',
      msg: 'Refresh the browser once you receive the text message or click on the link in the message',
      timeout: 5000,
      isOpen: true
    });
    this.emailForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, EcomValidator.emailValidator])]
    });
    this.referForm = this.formBuilder.group({
      referralList: this.formBuilder.array([])
    });
    // display list
    for (let i = 1; i <= 6; i++) {
      this.addReferControl();
    }

    this.getMyIp();
  }

  getMyIp() {
    if (this.webstorage.localSt_ip) {
      this.LoadPage();
    } else {
      this.ecomservice.httpGetOuterResponseHeader(EcomNetworkUtils.GET_IP_ADDRESS + this.ecomservice.GetOlarConfigValue('ipgeolocation_key'), '', true).subscribe((response: HttpResponse<any>) => {
        if (response.status === 200) {
          this.webstorage.localSt_ip = response.body.ip;
            this.webstorage.localSt_latlng = response.body.latitude + ',' + response.body.longitude;
            this.webstorage.localSt_countrycode = response.body.country_code2;
          this.LoadPage();
        }
      });
    }

  }

  LoadPage() {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
        if (response.isSuccess) {
          if (!this.webstorage.localSt_client_id) {
            this.webstorage.localSt_client_id = response.listValue.oock_client_id;
          }
          // store public key
          this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
          this.getOrderStatus();
        }
      });
    } else {
      this.getOrderStatus();
    }
  }

  addReferControl() {
    const referralList = <FormArray>this.referForm.controls['referralList'];
    const referral = this.formBuilder.group({
      // name:['',Validators.compose([Validators.required])],
      // phonenumber: ['', Validators.compose([Validators.required])]
      name: [''],
      phonenumber: [''],
      statusMessage: [''],
      status: [false]
    });
    referralList.push(referral);
  }

  // Method to get the order status
  getOrderStatus() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['companyId'] && params['serviceId']) {
        this.webstorage.sessionSt_frompage = 'status';
        this.location.replaceState(this.location.path().split('?')[0], '');
        this.webstorage.sessionSt_status_companyid = params['companyId'];
        this.webstorage.sessionSt_status_serviceid = params['serviceId'];
        this.getOrderDetails();
      } else {
        this.getOrderDetails();
      }
      /*
      if (this.userServiceBase) {
        this.userServiceBase = this.webstorage.localSt_user_service_request;
        let serviceActiveId = this.webstorage.sessionSt_service_active_id;
        this.serviceType = this.webstorage.sessionSt_service_type;
        if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
          serviceActiveId = 1;
        }
        this.locationSelected = this.webstorage.sessionSt_location_selected;
        if (this.userServiceBase) {
          let userStoreIndex = -1;
          const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
            userStoreIndex = index;
            return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && !obj.serviceCompleted && obj.serviceType === this.serviceType;
          });

          if (selectedStore) {
            // remove from local storage if payment is successfull
            // if it is dinein paylater then dont remove keep it and remove after payment          
            //this.userServiceBase.selectedStoreServiceList.splice(userStoreIndex, 1);
            //this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceCompleted = true;


            // if it qr code order don't remove from local storage in order to get back his cart

            if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
              this.webstorage.sessionSt_service_active_id = 1;
              this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart = new StoreCartBase();
              this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems = [];
            } else {
              this.userServiceBase.selectedStoreServiceList.splice(userStoreIndex, 1);
            }
          }
          this.webstorage.localSt_user_service_request = this.userServiceBase;
          // after payment success clear the active id from session
          this.webstorage.clear('sessionst_serviceactiveid', 'SESSION');
        }
      }
      */
    });
  }

  // Method to get the order details
  getOrderDetails() {
    if (this.webstorage.sessionSt_status_companyid === null) {
      this.router.navigate(['home']);
    } else {
      // get status from db
      const companyId = this.webstorage.sessionSt_status_companyid;
      const serviceGuid = this.webstorage.sessionSt_status_serviceid;
      const url = EcomNetworkUtils.GET_DINEIN_COLLECTION_DELIVERY_STATUS + '?companyId=' + companyId + '&serviceId=' + serviceGuid;
      this.ecomservice.httpGet(url, '', true).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          if (response.isSuccess) {
            this.getMerchantCustomerLoyaltyDetails(companyId, response.listValue.UserMobile, response.listValue.UserDialCode, response['listValue']['sales_orders']['sales_order_guid']);
            this.olarPoints = response.listValue.order_olar_points_earned;
            if (this.olarPoints > 0) {
              this.OlarmePromotion();
            }
            this.driverAssigned = false;
            if (response.listValue.orderDeliveryDetails) {
              let deliveryDetails = response.listValue.orderDeliveryDetails;
              if (deliveryDetails.delivery_driver_name) {
                this.driverAssigned = true;
              }
              this.driverDetails.deliveryStatus = deliveryDetails.delivery_order_status;
              this.driverDetails.deliveryPartner = deliveryDetails.delivery_service_partner;

              this.driverDetails.trackingUrl = deliveryDetails.delivery_tracking_url;
              this.deliveryTrackingUrl1 = deliveryDetails.delivery_tracking_url;
              if (deliveryDetails.delivery_tracking_url && !this.deliveryTrackingUrl) {
                this.deliveryTrackingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(deliveryDetails.delivery_tracking_url);
              }
              this.driverDetails.name = deliveryDetails.delivery_driver_name;
              this.driverDetails.contact = deliveryDetails.delivery_driver_contact;
              this.driverDetails.vehiclenumber = deliveryDetails.delivery_vehicle_number;
              this.driverDetails.image = deliveryDetails.delivery_driver_image ? deliveryDetails.delivery_driver_image : this.driverDetails.image;
              this.driverDetails.lat = deliveryDetails.delivery_driver_lat;
              this.driverDetails.lng = deliveryDetails.delivery_driver_lng;
              this.driverDetails.last_updated = deliveryDetails.delivery_driver_location_last_updated_at;
            }
            this.orderDetails = response.listValue;
            this.paymentMethod = response.listValue.order_payment_method;
            this.discountsApplied = response.listValue.list_olarme_cashback_discount;
            this.rejectreason = response.listValue.oodcdr_reject_notes;
            this.referralDiscount = response.listValue.olarme_cashback_discount;
            this.refererinput.name = response.listValue.oodcdr_name;
            this.refererinput.company_guid = response.listValue.oodcdr_company_guid;
            this.refererinput.company_id = this.webstorage.sessionSt_status_companyid;
            this.refererinput.dial_code = response.listValue.UserDialCode;
            this.refererinput.mobile = response.listValue.UserMobile;
            this.taxList = response.listValue.ListOrderTax;
            if (response.listValue.Position) {
              this.position = response.listValue.Position;
            }
            if (response.listValue.Currency) {
              this.currency = response.listValue.Currency;
            }
            this.userSelectedStore.serviceCompanyName = response.listValue.CompanyName;
            this.LogoPath = response.listValue.CompanyLogoPath;
            this.orderDatetime = response.listValue.order_date_time;
            this.invoiceNumber = response.listValue.sales_orders.sales_order_id;
            this.paymentStatus = response.listValue.Payments.oodcdrp_status;
            this.CompanyBusinessNumber = response.listValue.CompanyBusinessNumber;
            this.statusinput.companyGuid = response.listValue.oodcdr_company_guid;
            this.statusinput.companyId = this.webstorage.sessionSt_status_companyid;
            this.statusinput.locationGuid = response.listValue.oodcdr_location_guid;
            this.statusinput.oocrs_oodcdr_guid = this.webstorage.sessionSt_status_serviceid;
            //user details
            if (!this.userServiceBase) {
              this.userServiceBase = new UserServiceBase();
            }
            this.userServiceBase.userName = response.listValue.oodcdr_name;
            this.userServiceBase.userMobile = response.listValue.oodcdr_mobile;
            this.userServiceBase.userAddress = response.listValue.oodcdr_address;
            this.userServiceBase.landMark = response.listValue.oodcdr_address_landmark;
            this.userServiceBase.userCity = response.listValue.oodcdr_city;
            this.userServiceBase.userPostalCode = response.listValue.oodcdr_postal_code;
            // store details
            this.userSelectedStore.serviceDatetime = response.listValue.oodcdr_time;
            this.userSelectedStore.serviceEstimatedDatetime = new Date(new Date(this.userSelectedStore.serviceDatetime).setMinutes(new Date(this.userSelectedStore.serviceDatetime).getMinutes() + response.listValue.DeliveryEndTime));
            this.userSelectedStore.storeCart.orderId = response.listValue.sales_orders.sales_order_number;
            this.userSelectedStore.serviceLocationContact = response.listValue.LocationContact;
            this.userSelectedStore.serviceLocationAddress = response.listValue.LocationAddress;
            this.serviceType = response.listValue.oodcdr_type;

            this.userSelectedStore.storeCart.orderItems = [];
            response.listValue.sales_orders.mm_sales_order_items.forEach(item => {
              const objItem = new ItemBase();
              objItem.itemName = item.soi_item_name;
              objItem.quantity = Number(item.mm_sales_order_items_standard_composite_variant_service_details[0].soiscvsd_quantity);
              objItem.priceEach = Number(item.mm_sales_order_items_standard_composite_variant_service_details[0].soiscvsd_price);
              objItem.totalPrice = Number(objItem.priceEach * objItem.quantity);
              // variant
              objItem.variantList = [];
              item.mm_sales_order_items_standard_composite_variant_service_details.forEach(variant => {
                const objVariant = new VariantBase();
                objVariant.variantName = variant.soiscvsd_name;
                objItem.variantList.push(objVariant);
              });

              // modifier set
              objItem.modifierSetList = [];
              item.mm_sales_order_modifier_mapping.forEach(modSet => {
                const objModifierSet = new ModifierSetBase();
                objModifierSet.modifierName = modSet.somm_modifier_name;
                objModifierSet.modifierOptions = [];
                modSet.mm_sales_order_modifier_mapping_options.forEach(option => {
                  if (option.sommo_quantity > 0) {
                    const objModifierSetOption = new ModifierSetOptionBase();
                    objModifierSetOption.optionName = option.sommo_option_name;
                    objItem.totalPrice = Number(objItem.totalPrice + (option.sommo_price * option.sommo_quantity));
                    objModifierSet.modifierOptions.push(objModifierSetOption);
                  }
                });

                objItem.modifierSetList.push(objModifierSet);
              });
              this.userSelectedStore.storeCart.orderItems.push(objItem);
            });
            this.userSelectedStore.storeCart.orderDeliveryCharge = Number(response.listValue.sales_orders.sales_order_delivery_charge_total);
            this.userSelectedStore.storeCart.orderTax = Number(response.listValue.sales_orders.sales_order_tax_total);
            this.userSelectedStore.storeCart.orderSubTotal = Number(response.listValue.sales_orders.sales_order_gross_total);

            let orderTotalAmount = 0;
            let delTax = response.listValue.ListOrderTax.find(obj => {
              return obj.TaxGuid === response.listValue.sales_orders.sales_order_delivery_tax_guid;
            });
            if (response.listValue.tax_type === 'TAX_IN') {
              orderTotalAmount = orderTotalAmount + Number(response.listValue.sales_orders.sales_order_gross_total) + Number(response.listValue.sales_orders.sales_order_delivery_charge_total) + Number(response.listValue.sales_orders.sales_order_delivery_tax_amount);
            } else {
              if (delTax === undefined) {
                orderTotalAmount = orderTotalAmount + Number(response.listValue.sales_orders.sales_order_gross_total) + Number(response.listValue.sales_orders.sales_order_tax_total) + Number(response.listValue.sales_orders.sales_order_delivery_charge_total) + Number(response.listValue.sales_orders.sales_order_delivery_tax_amount);
              } else {
                orderTotalAmount = orderTotalAmount + Number(response.listValue.sales_orders.sales_order_gross_total) + Number(response.listValue.sales_orders.sales_order_tax_total) + Number(response.listValue.sales_orders.sales_order_delivery_charge_total);
              }
            }
            if (response.listValue.list_olarme_cashback_discount) {
              response.listValue.list_olarme_cashback_discount.forEach(element => {
                orderTotalAmount = orderTotalAmount - Number(element.ooocd_amount)
              });
            }
            this.userSelectedStore.storeCart.orderTotal = Number(orderTotalAmount) < 0 ? 0 : Number(orderTotalAmount);
            this.userSelectedStore.storeCart.orderDiscountTotal = Number(response.listValue.oodcdr_menu_discount_amount);
            this.updateStatusMessage(response.listValue.oodcdr_status);
            if (response.listValue.oodcdr_status === 'INPROGRESS' || response.listValue.oodcdr_status === 'DRAFT') {
              this.getStatus();
              this.updateStatusTime(response);
            } else {
              if (response.listValue.oodcdr_status === 'COMPLETE' || response.listValue.oodcdr_status === 'READY' || response.listValue.oodcdr_status === 'REJECT') {
                this.setProgressBarPercentage(100, '100%');
              }
            }
            if (this.webstorage.sessionSt_settings) {
              this.settings = this.webstorage.sessionSt_settings;
            } else {
              this.getCompanySettings(response.listValue);
            }
          }
        }
      });
    }
  }

  // Method to get the company settings
  getCompanySettings(value) {
    const locationguid = value.oodcdr_location_guid;
    const companyGuid = value.oodcdr_company_guid;
    // get the companysettings
    const locationselected = {
      oocls_location_guid: locationguid,
      oocls_is_display: true,
      location_qrscanned: false,
      oocls_company_id: this.webstorage.sessionSt_status_companyid,
      oocls_company_guid: companyGuid,
      oocls_location_timezone_id: value.LocationTimeZoneId
    };
    // get location related settings
    this.ecomservice.httpPost(EcomNetworkUtils.POST_GET_LOCATIONS_SETTINGS, locationselected, '', true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
          this.settings = response.listValue;
          this.webstorage.sessionSt_settings = this.settings;
        }
      }
    });
  }

  setProgressBarPercentage(number: number, percentage: string) {
    this.statusWidthNumber = number;
    this.statusWidth = percentage;
  }

  // Method to get the auto status
  GetStatusAuto() {
    const pageurl = this.router.url;
    if (pageurl === '/status-delivery' || pageurl.includes('/status-delivery')) {
      this.ecomservice.httpPost(EcomNetworkUtils.POST_GET_ORDER_STATUS, this.statusinput, '', false).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          if (response.isSuccess) {
            if (response.listValue.RejectionNotes) {
              this.rejectreason = response.listValue.RejectionNotes;
            }
            this.statusinput.oocrs_guid = response.listValue.oocrs_guid;
            this.statusinput.OrderStatus = response.listValue.OrderStatus;
            this.statusMessage = response.listValue.oocrs_remarks;
            this.paymentStatus = response.listValue.PaymentStatus;
            if (response.listValue.OrderStatus !== 'INPROGRESS') {
              if (response.listValue.OrderStatus === 'COMPLETE' || response.listValue.OrderStatus === 'READY' || response.listValue.OrderStatus === 'REJECT') {
                this.setProgressBarPercentage(100, '100%');
              }
            } else if (response.listValue.OrderStatus === 'INPROGRESS') {
              const kitchentime = Number(response.listValue.oocrs_time);
              const secondsElapsed = Number(response.listValue.secondsElapsed);
              const secondsRemaining = Number(response.listValue.secondsRemaining);
              let elapsedWidth = Number((secondsElapsed / (secondsElapsed + secondsRemaining)) * 100);
              this.statusWidthNumber = elapsedWidth;
              this.statusWidth = (this.statusWidthNumber + elapsedWidth) + '%';
              let timeleftMins = secondsRemaining / 60;
              if (secondsRemaining > 0) {
                this.percentageWidth = Number((1 / (secondsRemaining + secondsElapsed)) * 100);
                clearTimeout(this.timeoutFunc);
                clearInterval(this.timeoutFunc);
                this.updateStatusWidth(secondsRemaining);
                timeleftMins = Number(timeleftMins.toFixed(0));
                this.timeleft = (timeleftMins < 10 ? '0' + timeleftMins : timeleftMins) + ' mins';
                if (response.listValue.oocrs_status_requested) {
                  this.GetStatusDisable = true;
                  this.statusCheckMessage = 'Getting restuarant response';
                } else {
                  if (timeleftMins <= 5) {
                    this.statusCheckMessage = 'status check available now';
                    this.GetStatusDisable = false;
                  } else {
                    if (response.listValue.oocrs_notification_received) {
                      this.statusCheckMessage = 'Need another ' + timeleftMins + ' minutes';
                    } else {
                      this.statusCheckMessage = 'Status check available 5 min before the due time';
                    }
                    this.GetStatusDisable = true;
                  }
                }
              } else {
                if (response.listValue.oocrs_status_requested) {
                  this.GetStatusDisable = true;
                  this.statusCheckMessage = 'Getting restuarant response';
                } else {
                  this.statusCheckMessage = 'status check available now';
                  this.GetStatusDisable = false;
                }
                this.statusWidthNumber = 100;
                this.statusWidth = '100%';
              }

              this.progressEndTime = response.listValue.ServiceEndTime;
              this.progressStartTime = response.listValue.ServiceStartTime;
              this.setEndTime();
              //}
            }
            this.updateStatusMessage(this.statusinput.OrderStatus);
            this.driverAssigned = false;
            if (response.listValue.orderDeliveryDetails) {
              let deliveryDetails = response.listValue.orderDeliveryDetails;
              if (deliveryDetails.delivery_driver_name) {
                this.driverAssigned = true;
              }
              this.driverDetails.deliveryStatus = deliveryDetails.delivery_order_status;
              this.driverDetails.deliveryPartner = deliveryDetails.delivery_service_partner;
              // this.driverDetails.trackingUrl = deliveryDetails.delivery_tracking_url;
              // if (deliveryDetails.delivery_tracking_url && !this.deliveryTrackingUrl) {
              //   this.deliveryTrackingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(deliveryDetails.delivery_tracking_url);
              // }


              this.driverDetails.trackingUrl = deliveryDetails.delivery_tracking_url;
              if (deliveryDetails.delivery_tracking_url && !this.deliveryTrackingUrl) {
                this.deliveryTrackingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(deliveryDetails.delivery_tracking_url);
              }
              if (this.deliveryTrackingUrl1 !== deliveryDetails.delivery_tracking_url) {
                this.deliveryTrackingUrl1 = deliveryDetails.delivery_tracking_url;
                this.deliveryTrackingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(deliveryDetails.delivery_tracking_url);
              }
              this.driverDetails.name = deliveryDetails.delivery_driver_name;
              this.driverDetails.contact = deliveryDetails.delivery_driver_contact;
              this.driverDetails.vehiclenumber = deliveryDetails.delivery_vehicle_number;
              this.driverDetails.image = deliveryDetails.delivery_driver_image ? deliveryDetails.delivery_driver_image : this.driverDetails.image;
              this.driverDetails.lat = deliveryDetails.delivery_driver_lat;
              this.driverDetails.lng = deliveryDetails.delivery_driver_lng;
              this.driverDetails.last_updated = deliveryDetails.delivery_driver_location_last_updated_at;
            }
          }
          if (response.listValue.OrderStatus !== 'COMPLETE' || response.listValue.OrderStatus !== 'REJECT') {
            let temp = this;
            this.autoStatusTimeOut = setTimeout(function () {
              temp.GetStatusAuto();
            }, 1000 * 5); // autocall for every 1 minute
          }
        }
      });
    }
  }

  // Method to update the status time
  updateStatusTime(response) {
    if (response.listValue.ServiceStartTime) {
      this.progressStartTime = response.listValue.ServiceStartTime;
      this.progressEndTime = response.listValue.ServiceEndTime;
      // call the timer to update the status bar
      const secondsRemaining = Number(response.listValue.secondsRemaining);
      const secondsElapsed = Number(response.listValue.secondsElapsed);
      // update elapsed percentage to bar
      if (secondsElapsed > 0) {
        let elapsedWidth = Number((secondsElapsed / (secondsElapsed + secondsRemaining)) * 100);
        this.statusWidthNumber = elapsedWidth;
        this.statusWidth = (this.statusWidthNumber + elapsedWidth) + '%';
      }
      let timeleftMins = secondsRemaining / 60;
      if (secondsRemaining > 0) {
        this.percentageWidth = Number((1 / (secondsRemaining + secondsElapsed)) * 100);
        this.updateStatusWidth(secondsRemaining);
        timeleftMins = Number(timeleftMins.toFixed(0));

        this.timeleft = (timeleftMins < 10 ? '0' + timeleftMins : timeleftMins) + ' mins';
        if (timeleftMins <= 5) {
          this.statusCheckMessage = 'status check available now';
          this.GetStatusDisable = false;
        } else {
          this.statusCheckMessage = 'Status check available 5 min before the due time';
          this.GetStatusDisable = true;
        }
      } else {
        this.statusWidthNumber = 100;
        this.statusWidth = '100%';
        this.GetStatusDisable = false;
      }
    }
  }

  // Method to update the status message
  updateStatusMessage(status) {
    // status message
    if (status === 'DRAFT') {
      this.statusMessage = 'your order is placed & waiting for restaurant to accept';
      this.orderStatus = 'Placed';
    } else if (status === 'SCHEDULED') {
      this.statusMessage = 'your order is confirmed & scheduled';
      this.orderStatus = 'Scheduled';
    } else if (status === 'INPROGRESS') {
      this.statusMessage = 'preparing your order';
      this.orderStatus = 'in progress';
    } else if (status === 'REJECT') {
      this.statusMessage = 'your order is rejected';
      this.orderStatus = 'Rejected';
    } else if (status === 'COMPLETE') {
      this.statusMessage = 'your order is completed';
      this.orderStatus = 'Completed';
    } else if (status === 'READY') {
      this.statusMessage = 'your order is ready & picked for delivery';
      this.orderStatus = 'Ready';
    }
  }

  // Method to get the status
  getStatus() {
    this.ecomservice.httpPost(EcomNetworkUtils.POST_GET_ORDER_STATUS, this.statusinput, '', false).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
          if (response.listValue.RejectionNotes) {
            this.rejectreason = response.listValue.RejectionNotes;
          }
          this.statusinput.oocrs_guid = response.listValue.oocrs_guid;
          this.statusinput.OrderStatus = response.listValue.OrderStatus;
          // check if order is requested by customer
          if (response.listValue.oocrs_status_requested) {
            this.statusCheckMessage = 'Getting restuarant response';
            this.GetStatusDisable = true;
          } else {
            this.GetStatusDisable = false;
          }
          this.updateStatusMessage(this.statusinput.OrderStatus);
          let temp = this
          setTimeout(function () {
            temp.GetStatusAuto();
          }, 1000 * 5);
        }
      }
    });
  }

  // Method to handle the status button click event
  onStatusClick() {
    this.statusCheckMessage = 'Getting restuarant response';
    this.GetStatusDisable = true;
    const pageurl = this.router.url;
    if (pageurl === '/status-delivery' || pageurl.includes('/status-delivery')) {
      this.ecomservice.httpPost(EcomNetworkUtils.POST_ORDER_STATUS_NOTIFY, this.statusinput, '', true).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          if (response.isSuccess) {
            this.statusMessage = response.listValue.oocrs_remarks;
            if (response.listValue.OrderStatus !== 'INPROGRESS') {
              if (response.listValue.OrderStatus === 'COMPLETE' || response.listValue.OrderStatus === 'READY' || response.listValue.OrderStatus === 'REJECT') {
                this.setProgressBarPercentage(100, '100%');
              }
            } else if (response.listValue.OrderStatus === 'INPROGRESS') {
              if (response.listValue.oocrs_notification_received) {
                const kitchentime = Number(response.listValue.oocrs_time);
                const secondsElapsed = Number(response.listValue.secondsElapsed);
                const secondsRemaining = Number(response.listValue.secondsRemaining);
                let elapsedWidth = Number((secondsElapsed / (secondsElapsed + secondsRemaining)) * 100);
                this.statusWidthNumber = elapsedWidth;
                this.statusWidth = (this.statusWidthNumber + elapsedWidth) + '%';

                let timeleftMins = secondsRemaining / 60;
                if (secondsRemaining > 0) {
                  this.percentageWidth = Number((1 / (secondsRemaining + secondsElapsed)) * 100);
                  clearTimeout(this.timeoutFunc);
                  clearInterval(this.timeoutFunc);
                  this.updateStatusWidth(secondsRemaining);
                  timeleftMins = Number(timeleftMins.toFixed(0));
                  this.timeleft = (timeleftMins < 10 ? '0' + timeleftMins : timeleftMins) + ' mins';
                  if (response.listValue.oocrs_status_requested) {
                    this.GetStatusDisable = true;
                    this.statusCheckMessage = 'Getting restuarant response';
                  } else {
                    if (timeleftMins <= 5) {
                      this.GetStatusDisable = false;
                      this.statusCheckMessage = 'status check available now';
                    } else {
                      this.GetStatusDisable = true;
                      this.statusCheckMessage = 'Need another ' + timeleftMins + ' minutes';
                    }
                  }
                } else {
                  this.statusCheckMessage = 'status check available now';
                  this.statusWidthNumber = 100;
                  this.statusWidth = '100%';
                  this.GetStatusDisable = false;
                }
                this.progressEndTime = response.listValue.ServiceEndTime;
                this.setEndTime();
              }
            }
            this.updateStatusMessage(response.listValue.OrderStatus);
          } else {
            this.statusMessage = 'error in getting status please try again.';
          }
        }
      });
    }
  }

  // Method to update the status width
  updateStatusWidth(remainingTimeInSeconds) {
    const pageurl = this.router.url;
    if (pageurl === '/status-delivery' || pageurl.includes('/status-delivery')) {
      const timeInMins = Number(Number(remainingTimeInSeconds / 60).toFixed(0));
      this.timeleft = (timeInMins < 10 ? '0' + timeInMins : timeInMins) + ' mins';      // 
      // update for every 1 seconds
      remainingTimeInSeconds -= 1;
      this.statusWidthNumber = this.statusWidthNumber + this.percentageWidth;
      this.statusWidth = this.statusWidthNumber + '%';
      if (remainingTimeInSeconds > 0) {
        let temp = this;
        this.timeoutFunc = setTimeout(function () {
          temp.updateStatusWidth(remainingTimeInSeconds);
        }, 1000);
        return;
      }
    }
  }

  // Method to send the end time
  setEndTime(kitchentime = 0) {
    // recalculate the end time
    if (kitchentime > 0) {
      let endTime = (this.progressEndTime.split(' ')[0]).split(':');
      let ampm = this.progressEndTime.split(' ')[1];
      let min: any = Number(endTime[1]) + kitchentime;
      let hour: any = Number(endTime[0])
      if (min >= 60) {
        hour = hour + 1;
        min = 60 - min;
      }
      min = min < 10 ? '0' + min : min;
      hour = hour < 10 ? '0' + hour : hour;
      let endtime = Number(hour) <= 12 ? (hour + ':' + min) : ((hour % 12) + ':' + min)
      this.progressEndTime = endtime + ' ' + ampm;
    } else {
      let endTime = (this.progressEndTime.split(' ')[0]).split(':');
      let ampm = this.progressEndTime.split(' ')[1];
      let min: any = Number(endTime[1]) + kitchentime;
      let hour: any = Number(endTime[0])
      if (min >= 60) {
        hour = hour + 1;
        min = 60 - min;
      }
      min = min < 10 ? '0' + min : min;
      hour = hour < 10 ? '0' + hour : hour;
      let endtime = Number(hour) <= 12 ? (hour + ':' + min) : ((hour % 12) + ':' + min)
      this.progressEndTime = endtime + ' ' + ampm;
    }
  }

  // onStatusClick() {
  //   this.timeleft = this.timeleft - 1;
  //   this.toastr.toastrConfig.progressAnimation = 'increasing';
  //   this.toastr.toastrConfig.titleClass = 'text-dark font-weight-bold';
  //   this.toastr.toastrConfig.messageClass = 'toast-message text-dark';
  //   this.toastr.toastrConfig.toastClass = 'ngx-toastr bg-light';
  //   const individualConfig = {
  //     progressBar: true
  //   };
  //   this.toastr.success("you'll be notified soon, be patient!", 'Hi ' + this.userServiceBase.userName, individualConfig);
  // }

  // Method to handle the click event
  onCallClick(phonenumber) {
    // this.toastr.toastrConfig.progressAnimation = 'increasing';
    // this.toastr.toastrConfig.titleClass = 'text-dark font-weight-bold';
    // this.toastr.toastrConfig.messageClass = 'toast-message text-dark';
    // this.toastr.toastrConfig.toastClass = 'ngx-toastr bg-light';
    // const individualConfig = {
    //   progressBar: true
    // };
    // this.toastr.success("you'll get call back soon, be patient!", 'Hi ' + this.userServiceBase.userName, individualConfig);
    document.location.href = 'tel:' + phonenumber;
  }

  onMainMenuClick() {
    // const serviceActiveId = this.webstorage.sessionSt_service_active_id;
    // let userStoreIndex = -1;
    // const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
    //   userStoreIndex = index;
    //   return obj.serviceLocationGuid === this.locationSelected.oocls_location_guid && obj.serviceType === this.serviceType && obj.serviceCompleted;
    // });
    // let storeService = new StoreServiceBase();
    // selectedStore.servicePayment = null;
    // selectedStore.storeCart = null;
    // selectedStore.serviceEmail = null;
    // storeService = selectedStore;
    // storeService.serviceCompleted = false;
    // storeService.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length + 1;
    // this.userServiceBase.selectedStoreServiceList.push(storeService);
    // this.webstorage.sessionSt_service_active_id = storeService.serviceActiveId;
    // this.webstorage.localSt_user_service_request = this.userServiceBase;
    // this.router.navigate(['items']);
  }

  // Method to handle the receipt click event
  onViewReceiptClick(template) {
    this.modalRef = this.modalService.show(template, this.config);
    this.invoiceMsg = '';
  }

  // Method to handle the alert close event
  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = [];
  }

  onEmailClick(template) {
    this.invoiceMsg = '';
    this.invoiceRequest = false;
    this.modalRef = this.modalService.show(template, this.config);
  }

  onSendEmailClick() {
    if (this.emailForm.invalid) {
      Object.keys(this.emailForm.controls).forEach(key => {
        this.emailForm.get(key).markAsDirty();
      });
      return;
    } else {
      const input = {
        CompanyId: this.webstorage.sessionSt_status_companyid,
        OrderGuid: this.webstorage.sessionSt_status_serviceid,
        Type: 'DELIVERY',
        Email: this.emailForm.value.email
      };
      this.ecomservice.httpPost(EcomNetworkUtils.POST_SEND_INVOICE, input, '', true).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          if (response.isSuccess) {
            this.invoiceMsg = 'Email sent successfully, check your inbox';
            this.invoiceRequest = true;
            //this.closeInvoicAuto();
          } else {
            this.invoiceRequest = false;
            this.invoiceMsg = 'Error in sending email try after sometime';
          }
        }
      });
    }
  }

  onDownloadPdfClick() {
    const input = {
      CompanyId: this.webstorage.sessionSt_status_companyid,
      OrderGuid: this.webstorage.sessionSt_status_serviceid,
      Type: 'DELIVERY',
      Email: ''
    };
    this.ecomservice.httpPost(EcomNetworkUtils.POST_PRINT_PREVIEW, input, '', true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
          const linkSource = 'data:application/pdf;base64,' + response['listValue'].replace(/\s/g, '');
          const downloadLink = document.createElement("a");
          const fileName = "Invoice.pdf";
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          this.invoiceMsg = 'Invoice Generated Successfully';
          this.invoiceRequest = true;
          //this.closeInvoicAuto();
        } else {
          this.invoiceRequest = false;
          this.invoiceMsg = 'Error in generating invoice try after sometime';
        }
      }
    });
  }

  closeInvoicAuto() {
    let temp = this.modalRef;
    setTimeout(function () {
      temp.hide();
      //$('.modal').css({"display": "none"});
    }, 3000);
  }

  openReferModal(template) {
    this.modalRef = this.modalService.show(template, this.config);
    this.referForm.reset();
    this.referMessage = '';
  }

  closeReferModal() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
  }

  onReferClick() {
    this.referMessage = '';
    if (this.referForm.invalid) {
      Object.keys(this.referForm.controls).forEach(key => {
        this.referForm.get(key).markAsDirty();
      });
      this.referMessage = 'Invalid contact number';
      return;
    } else {
      // check for duplicate numbers
      var hasDuplicate = false;
      this.referForm.value.referralList.map(v => v.phonenumber).sort().sort((a, b) => {
        if (a !== undefined && b !== undefined) {
          if (a.number === b.number) hasDuplicate = true
        }
      })
      if (hasDuplicate) {
        this.referMessage = 'Duplicate phone numbers found!'
      } else {
        //this.referMessage = "no duplicate";
        const referralList = <FormArray>this.referForm.controls['referralList'];
        const listReferrals = [];
        referralList.value.forEach(element => {
          if (element.name && element.phonenumber) {
            const input = {
              oocr_referral_name: this.ecomservice.encryptWithKey(element.name),
              oocr_customer_name: this.ecomservice.encryptWithKey(this.refererinput.name),
              oocr_customer_dial_code: this.ecomservice.encryptWithKey(this.refererinput.dial_code),
              oocr_customer_mobile: this.ecomservice.encryptWithKey(this.refererinput.mobile),
              oocr_referral_dial_code: this.ecomservice.encryptWithKey(element.phonenumber.countryCode),
              oocr_referral_mobile: this.ecomservice.encryptWithKey(element.phonenumber.number),
              oocr_company_guid: this.refererinput.company_guid,
              oocr_company_id: this.ecomservice.encryptWithKey(this.refererinput.company_id)
            };
            listReferrals.push(input);
          }
        });
        const input = {
          Key: this.webstorage.localSt_olar_key,
          CompanyId: this.ecomservice.encryptWithKey(this.refererinput.company_id),
          ListReferrals: listReferrals
        };
        if (input.ListReferrals.length > 0) {
          this.ecomservice.httpPost(EcomNetworkUtils.POST_REFER_FRIEND, input, '', true).subscribe(response => {
            if (response['status'] === 403) {
              this.router.navigate(['unauthorized']);
            } else {
              if (response.listValues.length > 0) {
                response.listValues.forEach(element => {
                  // search for phone number index and update the status message
                  let referralIndex = -1;
                  const objReferral = this.referForm.value.referralList.find((obj, index) => {
                    if (obj.phonenumber) {
                      const phonenumber = obj.phonenumber.number.replace('-', '').replace(' ', '');
                      referralIndex = index;
                      return phonenumber === element.m_Item1;
                    }
                  });
                  if (objReferral !== undefined) {
                    this.referForm.controls['referralList']['controls'][referralIndex].controls['statusMessage'].setValue(element.m_Item3);
                    this.referForm.controls['referralList']['controls'][referralIndex].controls['status'].setValue(element.m_Item2);
                  }
                });
              }
              this.autoCloseModal();
            }
          });
        } else {
          this.referMessage = 'Enter name and phone number to refer';
          this.autoCloseModal();
        }
      }
    }
  }

  autoCloseModal() {
    let temp = this.modalRef;
    // setTimeout(function () {
    //   temp.hide();
    // }, 5000);
  }

  getReferralControlsList(form) {
    return form.get('referralList').controls;
  }

  OlarmePromotion() {
    this.modalRefOlarmePromotion = this.modalService.show(this.olarmepromotionpopup, this.configOlarmePromotionPopup);
    let temp = this.modalRefOlarmePromotion;
    setTimeout(function () {
      if (temp) {
        temp.hide();
        //$('.modal').css({"display": "none"});
      }
    }, 5000);
  }

  onCloseOlarmePromotionClick() {
    this.modalRefOlarmePromotion.hide();
    //$('.modal').css({"display": "none"});
  }

  overlayOpen() {
    this.overlayDisplay = true;
  }

  closeOverlay() {
    this.overlayDisplay = false;
  }

  contactUsEventEmitter(event) {
    this.overlayDisplay = false;
  }

  onChatStartClick() {
    this.chatUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://harishhg.3cx.in/callus/#harishhg');
    this.modalRefChatbox = this.modalService.show(this.chatbox, this.configChatPopup);
    // this.overlayDisplay = false;
    // this.window && this.window.$zoho.salesiq.floatwindow.visible('show');

  }

  listYourRestaurantClick() {
    this.overlayDisplay = false;
    window.open(this.ecomservice.GetOlarConfigValue('merchantmate'), "_blank");
  }

  onTrackMyDeliveryClick() {
    window.open(this.driverDetails.trackingUrl, "_self");
  }

  onTrackMyOrderClick() {
    this.modalRefOrderTrack = this.modalService.show(this.orderTrack, this.configOrderTrackPopup);
  }

  setTrackingUrl() {
    this.trackingUrl.nativeElement.src = this.driverDetails.trackingUrl;
  }

  onCloseOrderTrack() {
    this.modalRefOrderTrack.hide();
  }

  trackingURL() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.driverDetails.trackingUrl);

    // case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
    // case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
    // case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
    // case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
    // case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl
  }

  onCloseChatClick() {
    this.modalRefChatbox.hide();
  }
}
